var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import classnames from 'classnames';
var Spin = function (props) {
    var _a = props.strokeWidth, strokeWidth = _a === void 0 ? 3 : _a, _b = props.width, width = _b === void 0 ? 50 : _b, className = props.className, _c = props.style, style = _c === void 0 ? {} : _c, color = props.color;
    var styleObj = color ? { stroke: color } : {};
    return React.createElement("div", { className: classnames('sn-loader', className), style: __assign({ width: width }, style) },
        React.createElement("svg", { className: 'circular', viewBox: "25 25 50 50" },
            React.createElement("circle", { className: 'path', cx: "50", cy: "50", r: "20", fill: "none", strokeWidth: strokeWidth, style: styleObj, strokeMiterlimit: "10" })));
};
export default Spin;
